import React from "react";
import { Switch } from "react-router";
import Route, { IRoute } from "components/Route";
import { ROUTES } from "routes/constants";

import Cheatsheet from "screens/Homepage/Cheatsheet";
import Pricing from "screens/Homepage/Pricing";
import AboutUs from "screens/Homepage/AboutUs";
import Blog from "screens/Homepage/Blog";
import Article from "screens/Homepage/Blog/Article";
import NotFoundPage from "screens/Homepage/NotFoundPage";
import Customers from "screens/Homepage/Customers";
import CaseStudy from "screens/Homepage/Customers/CaseStudy";

const _LazyLoadedRoutes: IRoute[] = [
  {
    exact: true,
    path: ROUTES.pricing,
    component: Pricing
  },
  {
    exact: true,
    path: ROUTES.about,
    component: AboutUs
  },
  {
    exact: true,
    path: ROUTES.blog,
    component: Blog
  },
  {
    exact: true,
    path: `${ROUTES.blog}/:slug`,
    component: Article
  },
  {
    exact: true,
    path: ROUTES.quickstart,
    component: Cheatsheet
  },
  {
    exact: true,
    path: ROUTES.customers,
    component: Customers
  },
  {
    exact: true,
    path: `${ROUTES.customers}/:slug`,
    component: CaseStudy
  }
];

const LazyLoadedRoutes: React.FC = () => {
  return (
    <Switch>
      {_LazyLoadedRoutes.map((routeProps, index) => (
        <Route key={index} {...routeProps} />
      ))}
      <Route path="*" component={NotFoundPage} />
    </Switch>
  );
};

export default LazyLoadedRoutes;
